/**
 运营公司
 */
import React, { Component } from 'react';
import styles from './index.module.scss';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { message, Typography } from 'antd';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { XInput, XSelect, XOKButton, XCancelButton, showConfirm } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import commonModel from '@/reducers/operation/common/model';
import model from '@/reducers/operation/company/model';
import TableSetArea from './modal/TableSetArea';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import RateModal from './modal/RateModal';
import ButtonPerssion from '@/routes/ButtonPerssion';

const { Text } = Typography;
const expires = [
    { code: '1', value: '是' },
    { code: '0', value: '否' }
];

class Company extends Component {

    static propTypes = {
        history: PropTypes.object, // 路由history对象
        match: PropTypes.object,
        setBreadcrumbPaths: PropTypes.func,
        getCompanyList: PropTypes.func,
        companyList: PropTypes.object,
        getStatus: PropTypes.func,
        status: PropTypes.array,
        getProvinces: PropTypes.func,
        provinces: PropTypes.array
    }

    static defaultProps = {
        companyList: { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }
    }

    state = {
        modal: '',
        modalParam: {},
        companyName: '',
        expireItem: {},
        contactTel: '',
        statusItem: {},
        provinceItem: {},
        principalName: ''
    }

    componentDidMount() {
        const { getStatus, getProvinces, setBreadcrumbPaths, match } = this.props;
        setBreadcrumbPaths(match); // 自动识别面包屑
        getStatus({ enumName: 'CompanyInfoStatusEnum' });
        getProvinces({ id: 0 });
    }

    _searchHandle = (useCache) => {
        const { pageNum, pageSize, contactTel, principalName, companyName, expireItem, statusItem, provinceItem } = this.state;
        let query = {};
        query = {
            companyName,
            isExpire: expireItem.code,
            contactTel,
            principalName,
            status: statusItem.code,
            provinceId: provinceItem.id,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getCompanyList(query);
        KeepAlive.saveCache({ ...query, expireItem, statusItem, provinceItem }); // 【第3步，缓存查询状态】
    }

    _resetHandle = () => {
        this.setState({
            companyName: '',
            expireItem: {},
            contactTel: '',
            statusItem: {},
            provinceItem: {},
            principalName: ''
        }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    //创建运营公司
    _create = () => this._jumpPage('运营公司详情', '/create')

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }

    ///请求
    _request = (url, data, tip) => {
        http(url, data, 'POST')
            .then(() => {
                message.success(tip);
                this._searchHandle('useCache');
            })
            .catch(err => message.error(err.message));
    }

    // 表格操作
    _tableAction = (type, values) => {
        switch (type) {
            case 'detail':
                this._jumpPage('运营公司详情', `/detail/${values.companyInfoId}`);
                break;
            case 'edit':
                this._jumpPage('编辑运营公司', `/edit/${values.companyInfoId}`);
                break;
            case 'open':
                this._request('/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.switchCompanyStatus', { companyInfoId: values.companyInfoId, status: 'PASS' }, '启用操作成功');
                break;
            case 'ban':
                showConfirm('禁用后运营后台不可以登录',
                    <Text type='danger'>已完成相关业务结算，才操作禁用！</Text>,
                    () => this._request('/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.switchCompanyStatus', { companyInfoId: values.companyInfoId, status: 'DISABLE' }, '禁用操作成功'));
                break;
            case 'reset':
                this._request('/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.resetCompanyPwd', { companyInfoId: values.companyInfoId }, '重置密码操作成功');
                break;
            case 'set':
                this.setState({ modal: 'areaModal', modalParam: { companyInfoId: values.companyInfoId } });
                break;
            case 'change':
                this._jumpPage('变更运营公司', `/change/${values.companyInfoId}`);
                break;
            case 'raterecord':
                this._jumpPage('费率历史记录', `/raterecord/${values.companyInfoId}`);
                break;
            case 'rateModal':
                this.setState({ modal: 'rateModal', modalParam: values })
                break;
        }
    }

    //路由跳转
    _jumpPage = (title, url) => {
        const { history } = this.props;
        const baseUrl = '/home/operation/company';
        history.push({ pathname: `${baseUrl}${url}` });
    }

    // 渲染弹窗
    _renderModal = () => {
        const { modal, modalParam } = this.state;
        switch (modal) {
            case 'areaModal':
                return <TableSetArea data={modalParam} closeModal={this._closeModal} />;
            case 'rateModal':
                return <RateModal data={modalParam} closeModal={this._closeModal} />;
            default:
                return null;
        }
    }

    // 关闭弹窗
    _closeModal = (update) => {
        this.setState({ modal: '', modalParam: {} }, () => {
            if (update) this._searchHandle('useCache');
        });
    }

    render() {
        const { contactTel, companyName, expireItem, statusItem, provinceItem, principalName } = this.state;
        const { companyList, status, provinces } = this.props;

        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 调用查询接口初始化数据
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                label='运营公司名称'
                                placeholder='请输入运营公司名称'
                                value={companyName}
                                bindThis={this}
                                bindName='companyName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                label='负责人'
                                placeholder='请输入负责人姓名'
                                value={principalName}
                                bindThis={this}
                                bindName='principalName'
                            />
                        </SearchItem>
                        {/* <SearchItem>
                            <XSelect
                                label='是否到期'
                                placeholder='请选择是否到期'
                                renderData={expires}
                                dataIndex='value'
                                keyIndex='code'
                                value={expireItem.value}
                                bindThis={this}
                                bindName='expireItem'
                            />
                        </SearchItem> */}
                        <SearchItem>
                            <XInput
                                label='联系电话'
                                placeholder='请输入联系电话'
                                value={contactTel}
                                bindThis={this}
                                bindName='contactTel'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='状态'
                                placeholder='请选择状态'
                                renderData={status}
                                dataIndex='value'
                                keyIndex='code'
                                value={statusItem.value}
                                bindThis={this}
                                bindName='statusItem'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='省份'
                                placeholder='请选择省份'
                                renderData={provinces}
                                dataIndex='areaName'
                                keyIndex='id'
                                value={provinceItem.areaName}
                                bindThis={this}
                                bindName='provinceItem'
                                showSearch={true}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <ButtonPerssion code='operation/company/cjyygs' render={(hasPerssion, disabled) => {
                        if (hasPerssion) {
                            return <XOKButton disabled={disabled} style={{ width: '120px', marginTop: '10px' }} label='创建运营公司' onClick={this._create} />;
                        } else {
                            return null;
                        }
                    }} />
                    <TableContent renderData={companyList} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                    {this._renderModal()}
                </div>
            </KeepAlive>
        );
    }
}

export default connect((state) => ({
    companyList: state.operationCompany.companyList,
    status: state.operationCompany.status,
    provinces: state.operationCommon.provinces,
}), {
    ...commonModel.actions,
    ...model.actions,
    setBreadcrumbPaths
})(Company);